var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex pl-4"},[_c('span',{staticClass:"text"},[_vm._v("No data to display")]),_c('span',{staticClass:"hatch ml-2"})])
}]

export { render, staticRenderFns }